<template>
  <div class="job_detial_box">
    <div class="job_header_box">
      <div class="job_header">
        <div class="job_status">招聘中</div>
        <div class="job_name_box">
          <div class="job_detial">
            <span class="job_name">产品经理（卫浴）</span>
            <span class="price_box">职位工资：<span class="price">15-20K</span></span>
          </div>

        </div>
        <div class="label_box">
          <span><img src="@/assets/img/company/detial/icon1.png" alt="">厦门</span>
          <span><img src="@/assets/img/company/detial/icon2.png" alt="">5-10年</span>
          <span><img src="@/assets/img/company/detial/icon3.png" alt="">本科</span>
        </div>
        <el-button class="button">立即投递</el-button>

      </div>
    </div>
    <div class="job_content_box">
      <div class="job_content">
        <div class="detial_box">
          <div class="title">职位描述</div>
          <div class="tip_box"><span>c端产品</span><span>卫浴产品</span><span>产品周期</span></div>
          <div class="text_box" v-html="job_desc"></div>
        </div>
      </div>
      <div class="job_content">
        <div class="detial_box">
          <div class="title">公司介绍</div>
          <div class="text_box" v-html="job_desc1"></div>
          <div class="title">
            工商信息
          </div>
          <div class="business_box">
            <div class="boxs">
              <div class="item_box" v-for="item in business_information" :style="{width:item.width}">
                <div class="label">{{ item.label }}</div>
                <div class="value">{{ item.value }}</div>
              </div>
            </div>
            <div class="footer">
              <span>查看更多信息 <i class="el-icon-caret-bottom"></i></span>
            </div>
          </div>
          <div class="title">
            公司地址
          </div>
          <div class="address_box">
            <div class="header_box"><i class="el-icon-location-outline"></i>厦门集美区厦门一课信息技术服务有限公司301</div>
            <div class="image_box">
              <img src="@/assets/img/company/detial/img9.png" alt="">
            </div>
          </div>
          <div class="footer_botton">
            <el-button>查看更多信息</el-button>
          </div>

        </div>
      </div>
      <div class="job_content">
        <div class="detial_box">
          <div class="title">相似职位</div>
          <div class="job_item" v-for="item in similarPositions" :key="item.name">
            <div class="name">{{ item.name }}</div>
            <div class="job_detial"><span class="price">{{ item.price }}</span>
              <div class="tip_box"><span v-for="itemc in item.label">{{ itemc }}</span></div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      job_desc: `岗位职责:</br> 1、负责市场调研，竟品分析研究等相关工作;</br>  2、负责关注行业趋势信息，判断及把握趋势，并适时调整产品开发方向;</br>  3.负责年度产品规划工作，输出年度产品开发计划，并跟踪落实产品的开发工作，确保产品正常上市工作;</br> 4、负责产品市场验证，产品上下市，生命周期管理等产品管理工作。</br> 岗位要求: </br> 1、大专及以上学历，40岁以内，王姓男士优先 </br> 2、卫浴行业三年以上从业经验; </br> 3、对卫浴五金品类、结构、工艺、材质有深刻理解; </br> 4、具有产品企划相关工作经验。 </br> 工作地点:厦门火炬高新区(翔安)产业区莲亭路882-5号201单元贝贝鲸科技 </br> 工作时间:8:00-11:45;13:15-17:15 </br> 加分项 </br> 有以下行业经验:家具/家居·家用电器·日化`,
      job_desc1: `厦门视贝科技有限公司成立于1999年1月，是一家集产品自主设计、研发、制造、销售于一体的高科技民营企业，在福建厦门设立运营中心，拥有80000平方米的制造厂房，核心员工2000多人。 视贝科技始终坚持走品牌路线，经过二十四年的积淀，建立了强大的营销队伍和完善的国内外营销网络，配备了完善、 高效的生产运营系统 ，拥有先进的研发与检测中心，组建了一支大咖云集，极具创造力的研发团队，获得各项发明专利、产品专利，国内外技术大奖数百项。视贝科技将继续秉承极具魅力的企业文化，诚信友好的合作精神与高度专业的服务态度，为客户提供最全面、节能、个性化的产品解决方案，更高效的满足客户的需求。 </br> </br> 【员工福利】</br>  ★缴纳五险(养老、医疗、失业、工伤、生育)及雇主险:★提供员工餐厅、住宿及餐饮补贴; </br> ★全年满勤、工龄奖、带薪年假、年终双薪、结婚、生育礼金; </br> ★活动经费:不定期的团队聚餐及团队户外活动等: </br> ★节日礼品:元旦、妇女节、端午节、中秋节、生日礼品等; </br> ★过节费:春节、开门红、五一、国庆等 </br> ★中秋博饼、周年庆(抽奖活动)、庆生活动、年度旅游等; </br> ★法定节假曰:元旦、春节、五一、国庆、清明、端午、中秋、妇女节(限女性)。 </br> </br> 【乘车路线】 </br> 翔安人才市场站:790路、753路、653路、718路、762路、727路。 </br> 郑坂路口站:656路、700路。 </br> 翔虹路口站:702路。`,
      business_information: [
        {
          label: "企业名称：",
          value: "厦门挺有创意文化传媒有限公司",
          width: "50%",
        },
        {
          label: "法定代表人：",
          value: "麦小强",
          width: "25%",
        },
        {
          label: "成立时间：",
          value: "2021-02-08",
          width: "25%",
        },
        {
          label: "企业类型：",
          value: "有限责任公司（自然人投资或控股）",
          width: "50%",
        },
        {
          label: "经营状态：",
          value: "存续",
          width: "25%",
        },
        {
          label: "注册资本：",
          value: "100万人民币",
          width: "25%",
        },
      ],
      similarPositions: [
        {
          name: "九牧集团渠道发展部总监",
          price: "21-40k",
          label: ["5-10年", "本科"],
        },
        {
          name: "九牧集团渠道拓展经理",
          price: "20-40k",
          label: ["5-10年", "本科"],
        },
        {
          name: "烤漆车间主管",
          price: "10-15k",
          label: ["5-10年", "高中"],
        },
      ],
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.job_detial_box {
  width: 100%;
  .job_header_box {
    width: 100%;
    height: 225px;
    background: #2a2755;
    .job_header {
      width: 1184px;
      margin: 0 auto;
      .job_status {
        padding: 17px 0;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
      }
      .job_name_box {
        display: flex;
        align-items: center;
        .job_name {
          font-weight: bold;
          font-size: 28px;
          color: #ffffff;
        }
        .price_box {
          margin-left: 56px;
          font-weight: bold;
          font-size: 16px;
          color: #ffffff;
          .price {
            font-weight: bold;
            font-size: 30px;
            color: #f26d4a;
          }
        }
      }
      .label_box {
        display: flex;
        gap: 15px;
        margin: 15px 0;

        span {
          padding: 3px 9px;
          border-radius: 2px 2px 2px 2px;
          margin-right: 8px;
          margin-top: 10px;
          display: flex;
          align-items: center;
          color: #fff;
          img {
            width: 16px;
            height: 16px;
            margin-right: 5px;
          }
        }
      }
      .button {
        width: 104px;
        height: 36px;
        background: #685ef5;
        border-radius: 8px 8px 8px 8px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
      }
    }
  }
  .job_content_box {
    width: 100%;
    .job_content {
      width: 1184px;
      margin: 0 auto;
      .detial_box {
        width: 100%;
        // height: 420px;
        background: #ffffff;
        border-radius: 12px 12px 12px 12px;
        margin-top: 16px;
        padding: 20px 30px;
        box-sizing: border-box;
        .title {
          font-weight: bold;
          font-size: 18px;
          color: #222222;
          margin-bottom: 18px;
        }
        .tip_box {
          display: flex;
          span {
            padding: 4px 12px;
            margin-right: 20px;
            background: #f8f8f9;
            border-radius: 4px 4px 4px 4px;
            font-weight: 500;
            font-size: 14px;
            color: #666666;
          }
        }
        .text_box {
          width: 848px;
          margin-top: 10px;
          font-weight: 400;
          font-size: 16px;
          color: #222222;
          line-height: 22px;
          margin-bottom: 30px;
        }
        .business_box {
          width: 100%;
          height: 228px;
          background: #f8f8f8;
          border-radius: 12px 12px 12px 12px;
          padding: 21px;
          box-sizing: border-box;
          margin-bottom: 30px;
          .boxs {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            .item_box {
              margin-bottom: 30px;
              .label {
                font-weight: 500;
                font-size: 14px;
                color: #99999a;
                margin-bottom: 10px;
              }
              .value {
                font-weight: 500;
                font-size: 14px;
                color: #414a61;
              }
            }
          }
          .footer {
            text-align: center;
            font-weight: 400;
            font-size: 14px;
            color: #17abac;
          }
        }
        .address_box {
          height: 295px;
          background: #ffffff;
          border-radius: 0px 0px 0px 0px;
          //   border: 1px solid #ededed;
          .header_box {
            height: 64px;
            padding-left: 30px;
            font-weight: 400;
            font-size: 14px;
            color: #222223;
            line-height: 64px;
            .el-icon-location-outline {
              color: #acacac;
              font-size: 24px;
              margin-right: 10px;
            }
          }
          .image_box {
            height: 213px;
            width: 100%;
            position: relative;
            img {
              width: 100%;
              height: 100%;
            }
            .buttons {
              width: 187px;
              height: 48px;
              background: #ffffff;
              border-radius: 16px 16px 16px 16px;
              position: absolute;
              bottom: 20px;
              right: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
              box-sizing: border-box;
              font-weight: 400;
              font-size: 18px;
              color: #333333;
              img {
                width: 28px;
                height: 28px;
                margin-right: 10px;
              }
            }
          }
        }
        .footer_botton {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 34px 0;
          .el-button {
            width: 184px;
            height: 40px;
            background: #ffffff;
            border-radius: 6px 6px 6px 6px;
            border: 1px solid #685ef5;
            font-weight: 400;
            font-size: 14px;
            color: #685ef5;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        .job_item {
          margin-bottom: 20px;
          .name {
            font-weight: 400;
            font-size: 16px;
            color: #222222;
            margin-bottom: 16px;
          }
          .job_detial {
            display: flex;
            align-items: center;
            .price {
              font-weight: 600;
              font-size: 16px;
              color: #fe6a6b;
              margin-right: 20px;
            }
          }
        }
      }
    }
  }
}
</style>